import { english } from "./english";
import { spanish } from "./spanish";
import { french } from "./french";
import { chineseSimplified } from "./chineseSimplified";
import { chineseTraditional } from "./chineseTraditional";
import { japanese } from "./japanese";
import { korean } from "./korean";

export const languages = [
  { ...chineseTraditional, key: "chineseTraditional" },
  { ...chineseSimplified, key: "chineseSimplified" },
  { ...english, key: "english" },
  { ...french, key: "french" },
  { ...japanese, key: "japanese" },
  { ...korean, key: "korean" },
  { ...spanish, key: "spanish" },
];

// Function to get language data by name
export const getLanguageData = (key) =>
  languages.find((lang) => lang.key === key);
